import { useEffect, useRef, useState } from "react";
import { getSocket } from "../../lib/socket";
import { SocketContext } from "../../hooks/use-socket";
import DecryptData from "../../utils/Decrypt";
import { toast } from "react-toastify";
import NotificationToast from "../ui/NotificationToast";

export function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    socketRef.current = socket;

    // ── Helpers ──────────────────────────────────────────────────────────────
    const userData = DecryptData("aTaDrEsU") || {};

    const userId = userData?.userId;
    const username = userData?.user_name;

    console.log("[SocketProvider] User data:", userData);

    const onConnect = () => {
      console.log("[Socket] Connected:", socket.id);
      setIsConnected(true);

      socket.emit("join_notif_room", { id: userId, username });
      console.log("[Socket] Joined notification room for userId:", userId);
    };

    const onDisconnect = (reason) => {
      console.log("[Socket] Disconnected:", reason);
      setIsConnected(false);
    };

    const onNotification = (data) => {
      console.log("[Socket] Raw notification received:", data);
      let parsed = data;
      // If backend sends stringified JSON → parse it
      if (typeof data === "string") {
        try {
          parsed = JSON.parse(data);
        } catch (err) {
          console.error("Notification JSON parse failed:", err, data);
        }
      }
      console.log("type", typeof data === "string");
      console.log("parsed", parsed);

      // Do not show progress type notifications in the panel or toast popup
      if (parsed?.type === "progress") {
        return;
      }

      setNotifications((prev) => [parsed, ...prev]);

      // Show top-center notification popup
      toast(<NotificationToast notification={parsed} />, {
        containerId: "notifications",
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    };

    const onConnectError = (err) => {
      console.error("[Socket] Connection error:", err.message);
    };

    // ── Register listeners ────────────────────────────────────────────────────
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("metascroll_receive_notification", onNotification);
    socket.on("connect_error", onConnectError);

    // ── Connect ───────────────────────────────────────────────────────────────
    if (!socket.connected) {
      socket.connect();
    }

    // ── Cleanup ───────────────────────────────────────────────────────────────
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("metascroll_receive_notification", onNotification);
      socket.off("connect_error", onConnectError);
      socket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        isConnected,
        notifications,
        setNotifications,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
}
